import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkConfig } from 'app/providers/StoreProvider';
import { ExtendedAxiosRequestConfig } from 'shared/api/types';
import { ResponseWithPagination } from 'shared/types/responses';

import { GlobalCatalogItem } from '../../types/CatalogItemSchema';

interface GlobalCatalogItemsRequestData {
    searchString?: string;
    categoryId?: string;
    abortController?: AbortController;
}

export const fetchGlobalCatalogItems = createAsyncThunk<
    ResponseWithPagination<GlobalCatalogItem[]>,
    GlobalCatalogItemsRequestData,
    ThunkConfig<string>
>(
    'catalogItem/fetchGlobalCatalogItem',
    async ({ searchString, categoryId, abortController }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        // if (!searchString) return;

        try {
            const config: ExtendedAxiosRequestConfig = {
                signal: abortController?.signal,
                params: { searchString, categoryId },
                keysToNotConvert: ['specifications'],
            };

            const response = await extra.api.get<
                ResponseWithPagination<GlobalCatalogItem[]>
            >(`/v1/catalogs/search-items`, config);

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
